export const DefaultUserMenu = ['index', 'changeFactory', 'logout']
export const liveUserMenu = ['index', 'changeFactory', 'logout']
